// src/components/HowToUseEcoSlide.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function HowToUseEcoSlide() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // 固定画像（日本語版）
  const images = [
    '/images/Takaraduka/01_WHILL.jpg',
    '/images/Takaraduka/02_WHILL.jpg',
    '/images/Takaraduka/03_WHILL.jpg',
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const totalPages = images.length;
  const currentImagePath = images[currentPage - 1];

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageLoaded(false);
    setImageError(true);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setImageLoaded(false);
      setImageError(false);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      setImageLoaded(false);
      setImageError(false);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      padding: '20px',
      maxWidth: '100%'
    }}>
      
      {/* 画像表示エリア */}
      <div style={{ 
        position: 'relative',
        marginBottom: '20px',
        maxWidth: '100%',
        border: '1px solid #ddd',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        {!imageLoaded && !imageError && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
            backgroundColor: '#f5f5f5',
            color: '#666'
          }}>
            {t('Saving...')}
          </div>
        )}
        
        {imageError && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
            backgroundColor: '#ffe6e6',
            color: '#d32f2f',
            padding: '20px'
          }}>
            {t('Faled to save data. Please try again.')}
            <br />
            {currentImagePath}
          </div>
        )}

        <img
          src={currentImagePath}
          alt={`guide page ${currentPage}`}
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{
            maxWidth: '100%',
            height: 'auto',
            display: imageLoaded ? 'block' : 'none'
          }}
        />
      </div>

      {/* ページナビゲーション */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '15px',
        marginBottom: '10px'
      }}>
        <button
          onClick={goToPreviousPage}
          disabled={currentPage <= 1}
          style={{
            padding: '8px 16px',
            backgroundColor: currentPage <= 1 ? '#f5f5f5' : '#007bff',
            color: currentPage <= 1 ? '#999' : 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: currentPage <= 1 ? 'not-allowed' : 'pointer',
            fontSize: '14px'
          }}
        >
          ← {t('map.buttons.retry')}
        </button>

        <span style={{ 
          fontSize: '16px', 
          fontWeight: 'bold',
          minWidth: '80px',
          textAlign: 'center'
        }}>
          {currentPage} / {totalPages}
        </span>

        {currentPage >= totalPages ? (
          <button
            onClick={() => navigate('/takaraduka')}
            style={{
              padding: '8px 16px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            {t('end')} →
          </button>
        ) : (
          <button
            onClick={goToNextPage}
            style={{
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            {t('Next')} →
          </button>
        )}
      </div>

      {/* ページインジケーター */}
      <div style={{ display: 'flex', gap: '5px' }}>
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              setCurrentPage(index + 1);
              setImageLoaded(false);
              setImageError(false);
            }}
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              border: 'none',
              backgroundColor: currentPage === index + 1 ? '#007bff' : '#ddd',
              cursor: 'pointer'
            }}
            title={`${index + 1} ${t('map.buttons.close')}`}
          />
        ))}
      </div>
    </div>
  );
}

export default HowToUseEcoSlide;
